export default __webpack_public_path__ + "static/media/Icon=Invoice.5d4ffc6f.svg";